import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantRoleList',
  props: {
    roles: {
      type: Array,
      required: false,
      default: () => []
    },
    userId: {
      type: String,
      required: false,
      default: null
    },
    scopeId: {
      type: Number,
      required: true
    },
    tenantId: {
      type: Number,
      required: false,
      default: 0
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    loadRolesInternally: {
      type: Boolean,
      required: false,
      default: true
    },
    availableRoles: {
      type: Array,
      required: false,
      default: () => []
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      loadedRoles: [],
      selectedRoles: [],
      search: ''
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    comboRoles() {
      return (this.loadRolesInternally === true ? this.loadedRoles : this.availableRoles).sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  },
  watch: {
    scopeId() {
      if (this.loadRolesInternally === true) {
        this.fetchRoles();
      }
    },
    roles(val) {
      this.selectedRoles = val;
    }
  },
  mounted() {
    if (this.loadRolesInternally === true) {
      this.fetchRoles();
    }
    this.selectedRoles = this.roles;
  },
  methods: {
    process(a) {
      const roles = cloneDeep(a);
      this.search = '';
      this.$emit('rolesChosen', roles.map(role => {
        return {
          id: role.id,
          name: role.name
        };
      }), this.scopeId, this.tenantId);
    },
    fetchRoles() {
      ApiService.fetchRoles(this.scopeId, this.userId).then(res => {
        this.loadedRoles = res;
      }).catch(error => {
        console.error(error);
      });
    },
    remove(item) {
      this.selectedRoles = this.selectedRoles.filter(role => {
        return item.id !== role.id;
      });
      this.process(this.selectedRoles);
    }
  }
};